import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../../models/property-step/property-step-model';
import { DraftFacade } from '@classifieds-sell/state';
import { PropertySectionBase } from '../../../property-section-base';

@Component({
    selector: 'property-summary-page-contact-details-section',
    templateUrl: './summary-page-contact-details-section.component.html',
    styleUrls: ['./summary-page-contact-details-section.component.scss']
})
export class ResidentialForSaleSummaryPageContactDetailsSectionComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    yourName: string;
    landLine: string;
    mobile: string;
    bestContactTime: string;
    registeredPropertyAgent: string;
    shouldContactMyAgent: string;
    agentAgency: string;
    agentName: string;
    agentMobile: string;
    agentLandLine: string;
    agentEmail: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {

            this.mobile = this.draftData.propertyInformation.mobile;
            this.landLine = this.draftData.propertyInformation.landLine;

            // 0 is a valid value for bestContactTime
            if (this.draftData.propertyInformation.contactTimes === 0 || this.draftData.propertyInformation.contactTimes) {
              this.bestContactTime = this.metadata.contactTimes.find(
                (f) =>
                  f.value === this.draftData.propertyInformation.contactTimes
              ).display;
            }

            this.registeredPropertyAgent = this.draftData.propertyInformation
              .isPropertyAgent
              ? 'Yes'
              : 'No';

            this.shouldContactMyAgent = this.draftData.propertyInformation
              .shouldContactAgent
              ? 'Yes'
              : 'No';

            if (this.draftData.propertyInformation.isPropertyAgent) {
              this.yourName = this.draftData.propertyInformation.name;
              this.agentAgency = this.draftData.propertyInformation.agency;
            }

            if (this.draftData.propertyInformation.shouldContactAgent) {
              this.agentAgency = this.draftData.propertyInformation.agentAgency;
              this.agentName = this.draftData.propertyInformation.agentName;
              this.agentMobile = this.draftData.propertyInformation.agentMobile;
              this.agentLandLine = this.draftData.propertyInformation.agentLandLine;
              this.agentEmail = this.draftData.propertyInformation.agentEmail;
            }

            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
